import React, { useState, useEffect, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

const AnimatedCounter = ({ from, to, duration = 2, suffix = "" }) => {
  const [count, setCount] = useState(from);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  useEffect(() => {
    if (isInView) {
      let startTimestamp = null;
      const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;
        const progress = Math.min((timestamp - startTimestamp) / (duration * 1000), 1);
        setCount(Math.floor(progress * (to - from) + from));
        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };
      window.requestAnimationFrame(step);
    }
  }, [isInView, from, to, duration]);

  // Special case for non-numeric like "24/7"
  if (typeof to === 'string') {
    return <span ref={ref}>{to}</span>;
  }

  return <span ref={ref}>{count}{suffix}</span>;
};

const About = () => {
  const stats = [
    { number: 500, suffix: '+', label: 'Projects Completed' },
    { number: 5, suffix: '+', label: 'Years Experience' },
    { number: 100, suffix: '%', label: 'Safety Record' },
    { number: '24/7', suffix: '', label: 'Support Available' },
  ];

  return (
    <section id="about" className="bg-dark border-t border-b border-white/5 py-12 relative z-20 -mt-2">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 divide-x divide-white/10">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="text-center px-4"
            >
              <div className="text-4xl md:text-5xl font-bold text-primary mb-2 font-barlow">
                {typeof stat.number === 'string' ? (
                  stat.number
                ) : (
                  <AnimatedCounter from={0} to={stat.number} suffix={stat.suffix} />
                )}
              </div>
              <div className="text-sm md:text-base text-gray-400 font-medium uppercase tracking-wider">
                {stat.label}
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default About;
